import moment from 'moment';

// Quick util to calculate the term (in months) between two dates.
export const getTerm = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return 12;
  }

  let start = moment(startDate);
  let end = moment(endDate);

  // moment.js's diff truncates the result. To get an inclusive term length
  // (e.g., July 1 to June 30 is 12 months), we get the floating-point
  // difference by passing `true` and then round it to the nearest whole number.
  return Math.round(end.diff(start, 'months', true));
}
